import _ from 'lodash';

const initialState = {
	manageOrdersListBackup: null,
	viewRequestsListBackup: null,
	requestReturnList: null,
	serialData:null,
	serialCreditData:null,
	requestCreditList: null,
	signatureDetails: null,
	orderDetails: null,
	originalOrderDetails:null,
	accountDetail: null,
	deletedOrderDetails: null,
	orderDetailsList: [],
	isBackOrdersAvailable: null,
	isBulkOrdersHoldAvailable: null,
	backOrders: null,
	bulkOrdersHold: null,
	createOrderPayload: null,
	orderableServices: [],
	isOrderPlaced: false,
	mobileView:false,
	quickOrderFormData: null,
	isOrderCreatedWithNewAddress: false,
	requestCreditPimdata:null,
	requestReturnPimdata:null,
	trackingDetails :[],
	pickAgentId: [{
		deliveryMethod: "SDS Delivery",
		loctype: "sds_loc"
	}, {
		deliveryMethod: "ADC Truckload",
		loctype: "adc_loc"
	},  {
		deliveryMethod: "ADC Box Truck",
		loctype: "adc_loc"
	}, {
		deliveryMethod: "ADC LTL",
		loctype: "adc_loc"
	}, {
		deliveryMethod: "SDS Will Call",
		loctype: "sds_will_call_loc"
	}, {
		deliveryMethod: "ADC Will Call",
		loctype: "adc_will_call_loc"
	}, {
		deliveryMethod: "SDS Delivery Next Day",
		loctype: "sds_loc"
	}, {
		deliveryMethod: "FedEx Ground",
		loctype: "adc_loc"
	}, {
		deliveryMethod: "ADC Velocity",
		loctype: "adc_loc"
	}, {
		deliveryMethod: "MATU Ocean Ocean Full Container",
		loctype: "adc_loc"
	}, {
		deliveryMethod: "Meet Truck",
		loctype: "mt_loc"
	}],
	workOrderAccountClassification: [
		"single family",
		"single family renovation",
		"multifamily for rent",
		"multifamily for sale",
		"home warranty",
		"government",
		"government reseller",
		"hud"
	],
	workOrderShippingMethod: [
		"SDS Delivery", 
		"Meet Truck"
	],
	decliningBalanceNewAccountClassification: [
		"apartment replacement dist",
		"appliance builder distributor",
		"aws pro - distributors",
		"direct property mgt rehab",
		"direct property mgt replacemen",
		"dpmr",
		"government",
		"home warranty",
		"hospitality distributor",
		"non national",
		"oem- direct",
		"single family",
		"single family renovation"
		],
	decliningBalanceAccountClassifications: [
		"single family",
		"single family renovation",
		"oem - direct",
		"government",
		"direct property mgt rehab",
		"direct property mgt replacement",
		"home warranty"
	],
	classificationExceptionList: [
		"single family",
		"single family renovation",
	],
	freeDeliveryList: [
		'DFI - WAIVE FREIGHT',
	],
	orderShippingDetails: null,
	orderAvailabilityFailedMsgList: [
		'ATP is currently not available due to planned down time.',
		'Try ATP again later'
	],
	itemAvailabilityFailedMsgList:[
		'No ATP rule defined for this item or one of its components',
		'Please pass valid Item#'
	],
	productStatus: [
		{
			productStatus: 'Prod TBD',
			supplyType: 'Planned Order',
			weightagePriority: 4,
		}, {
			productStatus: 'Prod TBD',
			supplyType: 'Purchase Order',
			weightagePriority: 4,
		}, {
			productStatus: 'In Transit',
			supplyType: 'Purchase Requisition',
			weightagePriority: 3,
		}, {
			productStatus: 'Sched Prod',
			supplyType: 'Work Order',
			weightagePriority: 3,
		}, {
			productStatus: 'In Transit',
			supplyType: 'Intransit',
			weightagePriority: 2,
		}, {
			productStatus: 'In Transit',
			supplyType: 'Intransit shipment',
			weightagePriority: 2,
		}, {
			productStatus: 'In Transit',
			supplyType: 'PO in receiving',
			weightagePriority: 2,
		}, {
			productStatus: 'On Hand',
			supplyType: 'On Hand',
			weightagePriority: 1,
		}
	],
	orgAttributes: null,
	availabilityError: null,
	lookUpSerialNoData: null,
	deletedItems: [],
	topIndicatorAddAttrBySiteNum: [],
	previousReturnRequestDetails: null,
	availabilityPricingOfImportedFile: null,
	availabilityOnChangeAddress: null,
	createOrderPayloadBackup: null,
	// Request return form params and errors updates
	requestReturnFilterListOfOrders: null,
	requestCreditFilterListOfOrders: null,
	manageOrderFormParams: null,
	updateBookedOrderConfirmationPageData: null,
	shippingMethodData: null,
	approveReturnsList: null,

	shippingMethodList: [
		{
			label: "SDS Delivery",
			value: "SDS Delivery",
			display: false,
		}, {
			label: "ADC Truckload",
			value: "ADC Truckload",
			display: false,
		}, {
			label: "ADC LTL",
			value: "ADC LTL",
			display: false,
		}, {
			label: "SDS Will Call",
			value: "SDS Will Call",
			display: false,
		}, {
			label: "ADC Will Call",
			value: "ADC Will Call",
			display: false,
		}, {
			label: "MATU Ocean Ocean Full Container",
			value: "MATU Ocean Ocean Full Container",
			display: false,
		}, {
			label: "LTIA Ocean Ocean Full Container",
			value: "LTIA Ocean Ocean Full Container",
			display: false,
		}, {
		// TO DO: WCP-7390: We will likely add this back after we are using the SDS Calendar API that includes capacity for Next Day.
		// 	label: "SDS Next Day Delivery(M038 – Hot Shot)",
		// 	value: "SDS Delivery Next Day",
		// 	display: false,
		// }, {
			label: "ADC Velocity",
			value: "ADC Velocity",
			display: false,
		}
	],
	prices: [],
	// TO DO: Static list
	creditTypeDropdownValues: {
		"Damage Allowances": [{
			label: 'Credit Only - Damage Allowance',
			value: 'CREDIT ONLY - DAMAGE ALLOWANCE',
		}],
		"Scrap": [{
            label: 'Credit Field Scrap Cabinet Frame Or Liner Twisted Warped',
            value: 'FS_CAB_DMG',
        }, {
            label: 'Credit Field Scrap Cabinets Can No Longer Be Leveled',
            value: 'FS_CAB_LEVEL',
        }, {
            label: 'Credit Field Scrap Ceramic Cooktop Broken',
            value: 'FS_CERAM_CT_BROKEN',
        }, {
            label: 'Credit Field Scrap Dishwasher Tub Cracked',
            value: 'FS_DISH_TUB_CRACKED',
        }, {
            label: 'Credit Field Scrap Door Seal Hinge Irreparably Damaged',
            value: 'FS_DOOR_SEAL_HINGE',
        }, {
            label: 'Credit Field Scrap Edges Sharp Beyond Repair',
            value: 'FS_SHARP_EDGES',
        }, {
            label: 'Credit Field Scrap Gas Or Freon Leaking Excessively',
            value: 'FS_GAS_FREON_LEAK',
        }, {
            label: 'Credit Field Scrap Internal Functional Parts Damage',
            value: 'FS_INTERNAL_DMG',
        }, {
            label: 'Credit Field Scrap Laundry Suspension Damage',
            value: 'FS_LAUNDRY_SUSP_DMG',
        }, {
            label: 'Credit Field Scrap Other',
            value: 'FS_OTHER',
        }, {
            label: 'Credit Field Scrap Oven Cavity Chipped Or Cracked',
            value: 'FS_CAVITY_CHIPPED',
		},  {
			label: ' Credit Field Scrap Excessive Service',
            value: 'FS_EXCESSIVE_SERVICE',
		},   {
			label: 'Credit Field Scrap Service Not Available',
            value: 'FS_SERVICE_NA',	
        }],
		"Delivery/Services/Fees": [{
			label: 'Credit Non Model Item Restocking',
			value: 'CREDIT_RESTOCKIN',
			serviceType: 'restocking'
		}, {
			label: 'Credit Non Model Item Service Contract',
			value: 'CREDIT_WARRANTY',
			serviceType: 'servicecontract'
		}, {
			label: 'Credit Non Model Item Delivery',
			value: 'CREDIT_DELIVERY',
			serviceType: 'deliveryhandlingetc'
		}],
		"As-is Credit/Rebill": [{
			label: 'Credit Rebill AsIs Change Account',
			value: 'CR_RB_ASIS_ACCT',
		}],
		"Price Adjustment - Credit/Rebill": [{
			label: 'Credit Display Model Home Allow Direct Contract Only',
			value: 'DISPLAY_MH',
		}, {
			label: 'Credit Pricing Contract Exception Model Not On Quote',
			value: 'PRICE_CONT_NOT_QUOTED',
		}, {
			label: 'Credit Pricing Contract Late Addition Of Model To Quote',
			value: 'PRICE_CONT_LATE_QUOTED',
		}, {
			label: 'Credit Pricing Contract Price Change On Quote',
			value: 'PRICE_CONT_QUOTE_CHANGE',
		}, {
			label: 'Credit Pricing Contract Substitution',
			value: 'PRICE_CONT_SUBSTITUTION',
		}, {
			label: 'Credit Pricing Retail ABD Bulletin Market Pricing',
			value: 'PRICE_RABD_BULLETIN',
		}, {
			label: 'Credit Pricing Retail ABD Late Addition Of Model To Quote',
			value: 'PRICE_RABD_LATE_QUOTED',
		}, {
			label: 'Credit Pricing Retail ABD Meet Comp Price Error',
			value: 'PRICE_RABD_MC_ERROR',
		}, {
			label: 'Credit Pricing Retail ABD Price Concession',
			value: 'PRICE_RABD_CONCESSION',
		}, {
			label: 'Credit Pricing Retail ABD Substitution',
			value: 'PRICE_RABD_SUBSTITUTION',
		}, {
			label: 'Credit Rebill Add Remove Service Contracts',
			value: 'CR_RB_WARRANTY',
		}, {
			label: 'Credit Rebill Contract Accommodation Sales',
			value: 'CR_RB_CONT_ACCOMMODATE',
		}, {
			label: 'Credit Rebill Contract Change Account',
			value: 'CR_RB_CONT_ACCT',
		}, {
			label: 'Credit Rebill Contract Debit Back Quote',
			value: 'CR_RB_CONT_DEBIT_BACK_QUOTE',
		}, {
			label: 'Credit Rebill Contract Lost Product',
			value: 'CR_RB_CONT_LOST',
		}, {
			label: 'Credit Rebill Contract Other',
			value: 'CR_RB_CONT_OTHER',
		}, {
			label: 'Credit Rebill Contract Repossession',
			value: 'CR_RB_CONT_REPO',
		}, {
			label: 'Credit Rebill Contract Service Contract',
			value: 'CR_RB_CONT_WARRANTY',
		}, {
			label: 'Credit Rebill Retail or ABD Accommodation Sales',
			value: 'CR_RB_RABD_ACCOMMODATE',
		}, {
			label: 'Credit Rebill Retail or ABD Change Account',
			value: 'CR_RB_RABD_ACCT',
		}, {
			label: 'Credit Rebill Retail or ABD Debit Back Quote',
			value: 'CR_RB_RABD_DEBIT_BACK_QUOTE',
		}, {
			label: 'Credit Rebill Retail or ABD Lost Product',
			value: 'CR_RB_RABD_LOST',
		}, {
			label: 'Credit Rebill Retail or ABD Other',
			value: 'CR_RB_RABD_OTHER',
		}, {
			label: 'Credit Rebill Retail or ABD Repossession',
			value: 'CR_RB_RABD_REPO',
		}, {
			label: 'Credit Rebill Retail or ABD Service Contract',
			value: 'CR_RB_RABD_WARRANTY',
		}, {
			label: 'Credit School Model',
			value: 'SCHOOL',
		}, {
			label: 'Credit Pricing Retail ABD Exception Model Not On Quote',
			value: 'PRICE_RABD_NOT_QUOTED',
		}, {
			label: 'Credit Pricing Retail ABD Price Change On Quote',
			value: 'PRICE_RABD_QUOTE_CHANGE',
		}, {
			label: 'Credit Pricing Retail ABD Price Protection',
			value: 'PRICE_RABD_PROTECT',
		}]
	},
	returnTypeDropdownValues: [{
		label: 'Return Crated',
		values: [{
			label: "Don't Need",
			value: 'RET_CRATED_NOT_NEEDED'
		}, {
			label: 'GE Business Decision',
			value: 'RET_CRATED_BUSINESS_DECISION'
		}, {
			label: 'Incorrect Color Ordered',
			value: 'RET_CRATED_ORD_WRONG_COLOR'
		}, {
			label: 'Incorrect Model Ordered',
			value: 'RET_CRATED_ORD_WRONG_MODEL'
		}, {
			label: 'Model Did Not Fit',
			value: 'RET_CRATED_NO_FIT'
		}, {
			label: 'Reposession',
			value: 'RET_CRATED_REPO'
		}, {
			label: 'Shipped Wrong Color',
			value: 'RET_CRATED_SHIP_WRONG_COLOR'
		}, {
			label: 'Shipped Wrong Model',
			value: 'RET_CRATED_SHIP_WRONG_MODEL'
		}]
	}, {
		label: 'Return Uncrated',
		values: [{
			label: 'Damaged Bent Warped',
			value: 'RET_UNC_DMG_BENT'
		}, {
			label: 'Damaged Cracked Fractured',
			value: 'RET_UNC_DMG_CRACK'
		}, {
			label: 'Damaged Creased',
			value: 'RET_UNC_DMG_CREASE'
		}, {
			label: 'Damaged Crushed',
			value: 'RET_UNC_DMG_CRUSH'
		}, {
			label: 'Damaged Dented Discolored',
			value: 'RET_UNC_DMG_DENT'
		}, {
			label: 'Damaged Door Unit Alignment',
			value: 'RET_UNC_DMG_ALIGN'
		}, {
			label: 'Damaged Part Missing',
			value: 'RET_UNC_DMG_PART'
		}, {
			label: 'Damaged Punctured',
			value: 'RET_UNC_DMG_PUNC'
		}, {
			label: 'Damaged Scratch Chip',
			value: 'RET_UNC_DMG_SCRATCH'
		}, {
			label: 'Damaged Tape Residue',
			value: 'RET_UNC_DMG_TAPE'
		}, {
			label: 'Defective',
			value: 'RET_UNC_DMG_DEFECTIVE'
		}, {
			label: "Don't Need",
			value: 'RET_UNC_NOT_NEEDED'
		}, {
			label: 'GE Business Decision',
			value: 'RET_UNC_BUSINESS_DECISION'
		}, {
			label: 'Incorrect Color Ordered',
			value: 'RET_UNC_ORD_WRONG_COLOR'
		}, {
			label: 'Incorrect Model Ordered',
			value: 'RET_UNC_ORD_WRONG_MODEL'
		}, {
			label: 'Loaner',
			value: 'RET_UNC_DMG_LOANER'
		}, {
			label: 'Model Did Not Fit',
			value: 'RET_UNC_NO_FIT'
		}, {
			label: 'Reposession',
			value: 'RET_UNC_REPO'
		}, {
			label: 'Shipped Wrong Color',
			value: 'RET_UNC_SHIP_WRONG_COLOR'
		}, {
			label: 'Shipped Wrong Model',
			value: 'RET_UNC_SHIP_WRONG_MODEL'
		}]
	}],
	// TO DO: Static list
	allowedCustomerClassCodes: [
		// "apartment replacement dist",
		// "appliance builder distributor",
		"oem - direct",
		"oem - dist",
	],
	accountCustomerClassCodes: [
		"premium incentive",
		"home warranty",
		"specialty"
	],
	accountSalesChannelCodes: [
		'hq'
	],
	requestReturnDetails: null,
	requestCreditDetails: null,
	bookedOrders: [],
	minimumDeliveryAmount: null,
	billingReference: null,
	createWorkOrderPayload: null
};

export default function order(state = initialState, action) {
    switch (action.type) {
		case 'SAVE_QUICK_ORDER_DATA':
			return {
				...state,
				quickOrderFormData: action.data
			}
		case 'SAVE_ORDERABLE_SERVICES':
			return {
				...state,
				orderableServices: action.data
			}
		case 'SAVE_MINIMUM_DELIVERY_AMOUNT':
			return {
				...state,
				minimumDeliveryAmount: action.data
			}
		case 'SET_AVAILABILITY_ERROR':
			return {
				...state,
				availabilityError: action.data
			}
		case 'IS_ORDER_PLACED':
			return {
				...state,
				isOrderPlaced: action.data
			}
		case 'SAVE_APPROVE_RETURNS_LIST':
			return {
				...state,
				approveReturnsList: action.data
			}
		case 'RESET_PRICES_TO_ORDER':
			return { ...state,
				prices: []
			};
		case 'SAVE_PRICES_TO_ORDER':
			var prices = [];
			if(action.data && action.data.responseObject && action.data.responseObject.items.length > 0){
				action.data.responseObject.items.map((item, index) =>{
					return prices.push(item)
				});
			}
			return { ...state,
				prices: state.prices.concat(prices)
			};
		case 'SAVE_SHIPPING_METHOD':
			return { ...state,
				shippingMethodData: {
					...action.data,
					responseObject: action.data.responseObject.replace(/-/g, " ")
				}
			};
		case 'UPDATE_REQUEST_RETURN_PARAMS':
			return {
				...state,
				requestReturnFilterListOfOrders: action.data
			}
		case 'SAVE_AVAIL_PRICING_OF_IMPORTED_FILE':
			return {
				...state,
				availabilityPricingOfImportedFile: action.data
			}
		case 'SAVE_AVAIL_ON_CHANGE_ADDRESS':
			return {
				...state,
				availabilityOnChangeAddress: action.data
			}
		case 'SAVE_CREATE_ORDER_PAYLOAD_BACKUP':
			return {
				...state,
				createOrderPayloadBackup: action.data
			}
		case 'SAVE_CREATE_WORK_ORDER_PAYLOAD':
			return{
				...state,
				createWorkOrderPayload: action.data
			}
		case 'CLEAR_DELIVERY_METHOD_FROM_BACKUP':
			const createOrderPayloadBackup = state.createOrderPayloadBackup;
			if(createOrderPayloadBackup && createOrderPayloadBackup.createOrderForm && createOrderPayloadBackup.createOrderForm.params) {
				createOrderPayloadBackup.createOrderForm.params.deliveryMethod = '';
			}
			return {
				...state,
				createOrderPayloadBackup: createOrderPayloadBackup
			}
		case 'UPDATE_MANAGE_ORDER_PARAMS':
			return {
				...state,
				manageOrderFormParams: action.data
			}
		case 'UPDATE_REQUEST_CREDIT_PARAMS':
			return {
				...state,
				requestCreditFilterListOfOrders: action.data
			}
		case 'SAVE_PREVIOUS_RETURN_AND_CREDIT_DETAILS':
			return {
				...state,
				previousReturnRequestDetails: action.data
			}
		case 'SAVE_ORG_ATTRIBUTES':
			return {
				...state,
				orgAttributes: action.data
			}
		case 'SAVE_LOOK_SERIAL_NO_DATA':
			return {
				...state,
				lookUpSerialNoData: action.data
			}
		case 'SAVE_BILLING_REFERENCES':
			return {
				...state,
				billingReference: action.data
			}
		case 'SAVE_MANAGE_ORDER_LIST_STATE_BACKUP':
			return {
				...state,
				manageOrdersListBackup: action.data
			}
		case 'SAVE_DELETED_ITEMS':
			return {
				...state,
				deletedItems: action.data
			}
		case 'SAVE_CREATE_ORDER_PAYLOAD':
			return {
				...state,
				createOrderPayload: action.data
			}
		case 'SAVE_UPDATE_BOOKED_ORDER_CONFIRMATION_PAGE_DATA':
			return {
				...state,
				updateBookedOrderConfirmationPageData: action.data
			}
		case 'SAVE_ORDER_SHIPPING_DETAILS':
			return {
				...state,
				orderShippingDetails: action.data
			};
		case 'SAVE_TRACKING_DETAILS':
			return {
				...state,
				trackingDetails: action.data
			};
		case 'SAVE_BOOKED_ORDERS':
			return {
				...state,
				bookedOrders: action.data
			}
		case 'SAVE_REQUEST_RETURN_DETAILS':
			return {
				...state,
				requestReturnDetails: action.data
			}
		case 'SAVE_REQUEST_CREDIT_DETAILS':
			return {
				...state,
				requestCreditDetails: action.data
			}
		case 'RESET_LOAD_INDICATOR_SITE_NUMBER':
			return {
				...state,
				topIndicatorAddAttrBySiteNum: [],
			}
		case 'SAVE_LOAD_INDICATOR_SITE_NUMBER':
			const topIndicatorAddAttrBySiteNum = state.topIndicatorAddAttrBySiteNum;
			if(!topIndicatorAddAttrBySiteNum.find(itm => itm.siteNumber === action.data.siteNumber && itm.attributeName === action.data.attributeName)) {
				topIndicatorAddAttrBySiteNum.push(action.data);
			}
			return {
				...state,
				topIndicatorAddAttrBySiteNum
			}
		case 'UPDATE_LOAD_INDICATOR_SITE_NUMBER':
			const data = [];
			state.topIndicatorAddAttrBySiteNum.forEach(itm => {
				if(itm.siteNumber === action.data.siteNumber && itm.attributeName === action.data.attributeName) {
					data.push(action.data);
				} else {
					data.push(itm);
				}
			});
			return {
				...state,
				topIndicatorAddAttrBySiteNum: data
			}
		case 'SAVE_BACK_ORDERS':
			return {
				...state,
				backOrders: action.data
			}
		case 'SAVE_BULK_ORDERS_HOLD':
			return {
				...state,
				bulkOrdersHold: action.data
			}
		case 'SAVE_VIEW_REQUEST_LIST_BACKUP':
			return {
				...state,
				viewRequestsListBackup: action.data
			}
		case 'SAVE_MOBILE_VIEW':
			return {
				...state,
				mobileView: action.data
		}
		case 'SAVE_REQUEST_RETURN_LIST':
			return {
				...state,
				requestReturnList: action.data
			}
		case 'SAVE_SERIAL_DATA':
			return {
				...state,
				serialData: action.data
			}
		case 'SAVE_REQUEST_CREDIT_LIST':
			return {
				...state,
				requestCreditList: action.data
			}
		case 'SAVE_SERIAL_CREDIT_DATA':
			return {
				...state,
				serialCreditData: action.data
			}
		case 'SAVE_REQUEST_CREDIT_PIMDATA':
			return {
				...state,
				requestCreditPimdata: action.data
			}
		case 'SAVE_REQUEST_RETURN_PIMDATA':
			return {
				...state,
				requestReturnPimdata: action.data
			}
		case 'SAVE_IS_BACKORDERS_AVAILABLE':
			return {
				...state,
				isBackOrdersAvailable: action.data
			}
		case 'SAVE_IS_BULK_ORDER_HOLD_AVAILABLE':
			return {
				...state,
				isBulkOrdersHoldAvailable: action.data
			}
		case 'SAVE_SIGNATURE_DETAILS':
			return {
				...state,
				signatureDetails: action.data
			}
		case 'SAVE_ORDER_DETAILS':
			return {
				...state,
				orderDetails: action.data
			}
		case 'SAVE_ORIGINAL_ORDER_DETAILS':
				return {
					...state,
					originalOrderDetails: action.data
			}
		case 'SAVE_DELETED_ORDER_DETAILS':
			return {
				...state,
				deletedOrderDetails: action.data
			}
		case 'SAVE_ORDER_DETAILS_LIST':
			let orderDetailsList = state.orderDetailsList;
			orderDetailsList.push(action.data);
            return {
                ...state,
                orderDetailsList: orderDetailsList
            }
		case 'IS_ORDER_CREATED_WITH_NEW_ADDRESS':
			return {
				...state,
				isOrderCreatedWithNewAddress: action.data
			}
		case 'RESET_ORDER_OBJECT_EXCEPTION':
			return {
				...state,
				isBackOrdersAvailable: state.isBackOrdersAvailable,
				isBulkOrdersHoldAvailable: state.isBulkOrdersHoldAvailable,
				backOrders: state.backOrders,
			}
		case 'RESET_ORDER_REDUCERS':
			return {
				...initialState,
				topIndicatorAddAttrBySiteNum: [],
			};
	    default:
	        return state;
    }
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/order.js